module.exports = __webpack_public_path__ + "img/feature_a05.854c5296.svg";